<script>

export default {
    name: 'UserConsentAanmelding',
    components: { },
    props: {
        consent: {
            type: Boolean,
            required: true,
            default: false
        },
        label: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            value: this.consent
        }
    },
    watch: {
        value() {
            this.$emit('update', this.value);
        },
        consent() {
            this.value = this.consent;
        }
    },
    mounted() {
        this.$store.state.signupIDTYPE = null;
        this.$store.state.signupIdnumber = '';
        this.$store.state.signupDEFAULTCOUNTRYCODE = null;
        this.$store.state.signupPHONENUMBER = '';
        this.$store.state.signupDAILCODE = '';
        this.$store.state.signupEmail = '';
        this.$store.state.signupCONTACTMETHODNR = 1;
        this.$store.state.signupBATCHNR = '';
        this.$store.state.signupLOCATIONFIRSTVAC = '';
        this.$store.state.signupDATEFIRSTVAC = '';
        this.$store.state.signupDATEFIRSTVACDD = '';
        this.$store.state.signupDATEFIRSTVACMM = '';
        this.$store.state.signupDATEFIRSTVACYYYY = '';
    }
}
</script>

<template>
    <div class="UserConsent">
       <div>
        <div class="section-block">
        <input
            v-model="value"
            id="user-consent-aanmelding"
            name="user-consent-aanmelding"
            type="checkbox">
        <label
            for="user-consent-aanmelding"
            v-html="$t('views.home.userConsentText')"/>
    </div>
       </div>
    </div>
</template>

<style lang="scss">
@import "@/styles/variables/index";

.UserConsent {
    padding: 20px;
    background: $color-lightgrey;
    border-radius: 12px;
    display: flex;
    align-items: center;

    input[type=checkbox] {
        width: 28px;
        height: 28px;
        margin-right: 20px;
        border-radius: 3px;
        border: 1px solid $color-coronacheck_black;
        cursor: pointer;
    }

    label {
        width: calc(100% - 48px);
        cursor: pointer;
    }
}
</style>
